export default __webpack_public_path__ + "static/media/jrc_alumni.33caad66.png";